import React, { Fragment, useContext, useRef } from 'react';
import { StaticContext } from '@sm/webassets';
import { Box } from '@wds/box';
import { Responsive } from '@wds/responsive';
import { PricingData } from './types';

import DetailsPackageHeader from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/DetailsPackageHeader';
import Categories from '~pricing/experiments/grow_2792_pnp_refresh_v1/components/Categories';

import useDetailsStyles from './useStyles';

export default function DetailsPackagesView({ packageData, discountInfo }: Readonly<PricingData>): JSX.Element {
  const { Details, Sticky, Mobile, Desktop } = useDetailsStyles({
    packageCount: packageData.length,
  });

  const { ssrEnv } = useContext(StaticContext);
  const stickyRef = useRef<HTMLDivElement>(null);

  if (!packageData) {
    return <></>;
  }

  return (
    <Box className={Details}>
      <Responsive maxWidth="md" defaultMatches={ssrEnv?.isMobile}>
        <Box className={Mobile}>
          {packageData.map((pricingPackage, index: number) => {
            if (pricingPackage) {
              const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
              const packageClassName = `package-${packageName}`;
              return (
                <div key={`Mobile-${packageName}`} className={packageClassName}>
                  <DetailsPackageHeader
                    comparisonSkuCosts={comparisonSkuCost}
                    discountInfo={discountInfo}
                    skuCosts={skuCost}
                    packageName={packageName}
                    index={`${index + 1}`}
                    data-testid="DetailsPackagesView__PackageHeader"
                  />
                  <Categories displayedPackages={[pricingPackage]} isMobile />
                </div>
              );
            }
            return null;
          })}
        </Box>
      </Responsive>

      <Responsive minWidth="md" defaultMatches={ssrEnv?.isDesktop}>
        <Box className={Desktop}>
          <Box
            className={Sticky}
            containerRef={stickyRef}
            id="PackagesHeader"
            data-testid="DetailsPackagesView__Sticky"
          >
            {packageData.map((pricingPackage, index: number) => {
              if (pricingPackage) {
                const { comparisonSkuCost, skuCost, packageName } = pricingPackage;
                return (
                  <Fragment key={`DetailsHeader-Desktop-Container${packageName}`}>
                    <DetailsPackageHeader
                      key={`DetailsHeader-Desktop${packageName}`}
                      comparisonSkuCosts={comparisonSkuCost}
                      discountInfo={discountInfo}
                      skuCosts={skuCost}
                      packageName={packageName}
                      index={`${index + 1}`}
                    />
                  </Fragment>
                );
              }
              return null;
            })}
          </Box>
          <Categories stickyRef={stickyRef} displayedPackages={packageData} />
        </Box>
      </Responsive>
    </Box>
  );
}
